import { createFileRoute } from '@tanstack/react-router'

import { PasswordResetPage } from '@/features/auth/components/password-reset/PasswordResetPage'
import { redirectAuthenticated } from '@/features/auth/route-access'

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: redirectAuthenticated,
  component: PasswordResetPage,
})
